import React, { FC } from "react";
import Title from "../../../UI/organisms/Title/Title";

import "./Modules.scss";
import { ModulesType } from "./Types";

const CardModules: FC<ModulesType> = ({ data }) => {
  const publicUrl = process.env.PUBLIC_URL;

  return (
    <section id="card-modules">
      <div className="card-modules__content">
        <Title info={data.title} tag="h2" />
        <ul className="card-modules__list">
          {data.cards.map((info) => (
            <li key={info.title} className="card-modules__item">
              {info.image && (
                <img
                  className="card-modules__item--img"
                  src={`${publicUrl}/${info.image}`}
                  alt={info.title}
                />
              )}
              {info.title && (
                <p
                  className="card-modules__item--title"
                  dangerouslySetInnerHTML={{ __html: `${info.title}` }}
                ></p>
              )}
              {info.description && (
                <p className="card-modules__item--desc">{info.description}</p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CardModules;
